import React, {useState} from 'react'
import Contact from '../Components/Contacts/Contact'
import Footers from '../Components/Footer/Footers'
import Hero from '../Components/HeroSection/Hero'
import { homeObjOne, homeObjTwo } from '../Components/InfoSection/Data'
import Info from '../Components/InfoSection/Info'
import CV from '../Components/MyCV/CV'
import Work from '../Components/MyWork/Work'
import AboutMe from "../Components/About/AboutMe"
import Navbar from '../Components/Navbar/Navbar'
import Sidebar from '../Components/SideBar/Sidebar'
import Skill from '../Components/Skills/Skill'
import Skill2 from '../Components/Skill2/Skill2'
import { Divider } from '@mui/material'



const Home = () => {
    const [isOpen, setIsOpen] =useState(false)

    const toggle =()=>{
        setIsOpen(!isOpen)

    }
    return (
        <>
        <Sidebar isOpen={isOpen} toggle={toggle}/>
        <Navbar toggle={toggle}/>
        <Hero/>
       
        <Skill2/>
        <AboutMe />
        <Skill/>
        
        {/* <Info {...homeObjOne}/> */}
        <Work/>    
        {/* <CV/> */}
        {/* <Info {...homeObjTwo}/> */}
        <Contact/>
        <Divider style={{marginTop:"2rem"}} />
        <Footers/>
        
        </>
    )
}

export default Home
